import React from 'react';
import { useSelector } from 'react-redux';
import { ActionButton, DialogTrigger, Flex, View } from '@adobe/react-spectrum';
import { toCSSColor } from '@printu/geom';
import TextStyle from '@spectrum-icons/workflow/TextStyle';
import { KnownFontFamilies } from 'app/core/markers/models';
import { EditorActions } from 'app/stores/editor/actions';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { Button } from 'app/views/components/editor/sidebar/Button';
const defaultFontText = {
    Helvetica: 'Normal',
    drawn: 'Hand draw',
    code: 'Courier',
};
const FontsGrid = (props) => {
    const { color, onSelect } = props;
    const commonStyle = {
        color: toCSSColor(color),
        fontSize: '1.4em',
    };
    return (React.createElement(Flex, { direction: "column", justifyContent: "stretch", gap: "size-100" }, KnownFontFamilies.map((font, index) => (React.createElement(ActionButton, { "data-test-id": `font-${index}`, key: font, onPress: () => onSelect(font), isQuiet: true },
        React.createElement("span", { style: Object.assign(Object.assign({}, commonStyle), { fontFamily: font }) }, defaultFontText[font]))))));
};
export const FontPickerBase = (props) => {
    const { onChange } = props;
    const currentColor = useSelector((state) => getProjectState(state).color);
    const mainViewLayout = configGet('desktopMainViewLayout', 'row');
    const placement = mainViewLayout === 'row' ? 'right' : 'bottom';
    return (React.createElement(Flex, { "data-test-id": "font-picker", width: "100%", direction: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(DialogTrigger, { type: "popover", mobileType: "tray", placement: placement, hideArrow: true },
            React.createElement(Button, { "data-test-id": "font-picker-trigger", label: "Font", Icon: TextStyle, onPress: () => ({}) }),
            close => (React.createElement(View, { padding: "size-200" },
                React.createElement(FontsGrid, { color: currentColor, onSelect: font => {
                        onChange(font);
                        close();
                    } }))))));
};
export const FontPicker = () => {
    const dispatch = useAppDispatch();
    const setFontFamily = React.useCallback((family) => {
        dispatch(ProjectActions.setProperty({
            property: 'format',
            value: { fontFamily: family },
        }));
    }, [dispatch]);
    return React.createElement(FontPickerBase, { onChange: setFontFamily });
};
export const FontDefaultsPicker = (props) => {
    const { toolId } = props;
    const dispatch = useAppDispatch();
    const onConfigChange = React.useCallback((value) => {
        dispatch(EditorActions.toolConfig({
            id: toolId,
            patch: { fontFamily: value },
        }));
    }, [toolId, dispatch]);
    return React.createElement(FontPickerBase, { onChange: onConfigChange });
};
